var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click', $event)},"mouseenter":function($event){_vm.$emit('mouseenter', $event)},"mouseleave":function($event){_vm.$emit('mouseleave', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4563395c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/btn.vue
// module id = null
// module chunks = 